import React, { useState } from 'react';
import classnames from 'classnames';
import styles from './RequestsContainer.module.scss';
import { Tab, Tabs } from 'react-bootstrap';
import { DataVendor, SearchEntity } from 'v2/models';
import RequestDetailTab from 'v2/common/DRM/Request/RequestDetailTab/RequestDetailTab';
import RequestResponseTab from 'v2/common/DRM/Request/RequestResponseTab/RequestResponseTab';
import SearchActivityTab from 'v2/common/DRM/ActivityTab/SearchActivityTab';

type TabKeys = 'details' | 'response' | 'allActivity';
type RequestTab = {
  eventKey: TabKeys;
  title: string;
};

const TABS: RequestTab[] = [
  {
    eventKey: 'details',
    title: `details`,
  },
  {
    eventKey: 'response',
    title: `response`,
  },
  {
    eventKey: 'allActivity',
    title: `All Activity`,
  },
];

interface RequestDetailProps {
  request: SearchEntity;
  dataVendor: DataVendor;
}

const RequestDetail = ({ dataVendor, request }: RequestDetailProps) => {
  const [tabSelected, setTabSelected] = useState<TabKeys>(TABS[0].eventKey);

  return (
    <div className={classnames(styles.tabs_container)}>
      <Tabs
        className={classnames('border-bottom-0')}
        activeKey={tabSelected}
        onSelect={(key) => setTabSelected(key as TabKeys)}
        role="tab"
        transition={false}
      >
        {TABS.map((item) => (
          <Tab
            key={item.eventKey}
            className="border-primary"
            eventKey={item.eventKey}
            unmountOnExit={true}
            title={`${item.title}`}
          >
            <div>
              {tabSelected === 'details' && (
                <RequestDetailTab request={request} dataVendor={dataVendor} />
              )}
              {tabSelected === 'response' && (
                <RequestResponseTab request={request} dataVendor={dataVendor} />
              )}
              {tabSelected === 'allActivity' && (
                <SearchActivityTab search={request} />
              )}
            </div>
          </Tab>
        ))}
      </Tabs>
    </div>
  );
};

export default RequestDetail;
